import { useEffect, useState } from "react";
import Breadcrumbs from "./Breadcrumbs";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  HMS_ERP_BILL_CLEAR_ADVANCE_TYPE,
  ERP_ALL_BANKS_DETAILS,
  ERP_CODE_TO_INVOICE_KEY,
  ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT,
  ERP_INVOICE_PAYMENT_MODE_WITH_ERP_PAYMENT_KEYS,
  ERP_LABEL_CANCEL,
  ERP_LABEL_GENERATE_INVOICE,
  ERP_LABEL_PAYMENT,
  ERP_LABEL_PAYMENT_BACK_ICON,
  ERP_LABEL_PAYMENT_CLOSE_ICON,
  ERP_LABEL_SUBMIT,
  ERP_PAYMENT_MODE,
  ERP_PAYMENT_PAGE_TYPE_CLOSE_PAYMENT,
  ERP_BILLING_TYPE_SO,
  MESSAGE_TYPE,
  HMS_ERPPAYMENT_PAYMENT_TYPE,
  ERP_PATIENT_PAYMENT_OBJ,
  ERP_VISIT_FIN_SUMMARY_TYPE_INV,
  PATIENT_VISIT_TYPE,
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  HMS_PAYMENT_REUQEST_STATUS,
  ERP_OUTSTANDING_BILL_LISTING,
  MASTER_LOCATION_DATA_LOCATION_KEY,
} from "../../core/constants/erpConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBanks,
  savePatientInvoice,
  savePatientPayment,
  settleUnclearedInvoices,
  successDispatch,
  updatePaymentRequest,
} from "./ERPActions/erpActions";
import ERPOutStandingBills from "./ERPOutStandingBills";
import { format, utcToZonedTime } from "date-fns-tz";
import { patientActions } from "../../core/actions";
import { addMonths, isBefore, isSameDay, parseISO, isValid } from "date-fns";
import { helperServices } from "../../shared/helper";
import React from "react";

export default function ERPPayment({
  patientId,
  visitId,
  balAmount,
  closePaymentPage,
  paymentTowards,
  paymentInitialisedMode,
  billClearAmt,
  clearOutstandingBillType,
  serverResposnes,
}) {
  const dispatch = useDispatch();
  const [balanceAmount, setBalanceAmount] = useState(0.0);
  const [payableAmount, setPayableAmount] = useState(0.0);
  const [bankDetails, setBankDetails] = useState();
  const [paymentType, setPaymentType] = useState(ERP_PAYMENT_MODE.CASH);
  const [invDetailsPayment, setInvDetailsPayment] = useState();
  const [amountPaid, setAmountPaid] = useState(0.0);
  const [selectedBank, setSelectedBank] = useState();
  const [voucherId, setVoucherId] = useState();
  const [showOutstandingBill, setShowOutstandingBill] = useState();
  const [outstandingBillClearType, setOutstandingBillClearType] = useState(
    clearOutstandingBillType,
  );
  const [billClearAmount, setBillClearAmount] = useState(billClearAmt);
  const [authorizationcode, setAuthorizationcode] = useState(null);
  const [partialPayments, setPartialPayments] = useState({});
  const [overPaid, setOverPaid] = useState(false);
  const [errormsg, setErrormsg] = useState();
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );
  const banksInfo = useSelector((state) => state.erpDetailsState?.erpBanksInfo);
  const loggerUserName = helperServices.getLoggedUserID();

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails,
  );
  const [description, setDescription] = useState(
    paymentTowards?.description || "",
  );

  const breadcrumbItems = [
    { label: "Patient", path: "/Home" },
    {
      label: patientInfo.id || "N/A",
      path:
        patientInfo &&
        patientInfo.id &&
        patientInfo.visit &&
        patientInfo.visit.id
          ? `/PatientSections/${patientInfo.id}/${patientInfo.visit.id}`
          : "",
    },
    {
      label: "Payment",
      path:
        patientInfo &&
        patientInfo.id &&
        patientInfo.visit &&
        patientInfo.visit.id
          ? `/billing/${(patientInfo && patientInfo.id) ?? patientInfo.id}/${
              (patientInfo && patientInfo.visit && patientInfo.visit.id) ??
              patientInfo.visit.id
            }`
          : "",
    },
  ];

  const requiresExactPayment =
    paymentInitialisedMode ===
      HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW ||
    paymentInitialisedMode ===
      HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES ||
    paymentInitialisedMode ===
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY ||
    paymentInitialisedMode ===
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY;

  const closePaymentComponent = (type) => {
    let data = {};
    let invDetailObj = {};
    if (
      invDetailsPayment !== null &&
      invDetailsPayment !== undefined &&
      type === ERP_LABEL_PAYMENT_BACK_ICON
    ) {
      invDetailObj = invDetailsPayment;
      invDetailObj.invoiceDetail.type =
        invDetailObj.invoiceDetail.type == ERP_BILLING_TYPE_SO
          ? ERP_BILLING_TYPE_SO
          : ERP_LABEL_PAYMENT_BACK_ICON;
      invDetailObj.invoiceDetail.billingStage =
        ERP_INVOICE_BILLING_STAGE_BACK_TO_BILLING_FROM_PAYMENT;
    }
    data = {
      type: type,
      invDetails: { ...invDetailObj.invoiceDetail },
    };
    if (type === ERP_PAYMENT_PAGE_TYPE_CLOSE_PAYMENT) {
      setInvDetailsPayment("");
    }
    closePaymentPage(data);
  };

  const getAllBanksDetails = async () => {
    const allbanks = await getAllBanks();
    if (allbanks && allbanks.bankInfo) {
      setBankDetails(allbanks.bankInfo);
      setSelectedBank(allbanks.bankInfo[0]);
      dispatch(successDispatch(ERP_ALL_BANKS_DETAILS, allbanks.bankInfo));
    }
  };

  const labelToCode = Object.entries(
    ERP_INVOICE_PAYMENT_MODE_WITH_ERP_PAYMENT_KEYS,
  ).reduce((acc, [code, label]) => {
    acc[label] = code;
    return acc;
  }, {});

  function updatePartialPaymentsList(numValue) {
    const modeKey = paymentType;
    let amountToStore = parseFloat(numValue) || 0;

    const updated = {
      ...partialPayments,
      [modeKey]: amountToStore,
    };

    setAmountPaid(amountToStore);
    setPartialPayments(updated);
    return updated;
  }

  const updatePaymentMode = (newMode) => {
    const newKey = newMode;

    // Do NOT overwrite the partialPayments using amountPaid (bug)
    const updatedPartialPayments = { ...partialPayments };

    // Calculate already paid (exclude the current mode)
    const sumOtherPayments = Object.entries(updatedPartialPayments).reduce(
      (sum, [mode, amt]) => {
        if (mode !== newKey) return sum + Number(amt || 0);
        return sum;
      },
      0,
    );

    // For normal payments (positive payableAmount) we want remaining >= 0.
    // For refund/advance (negative payableAmount) we want remaining <= 0.
    let remaining = 0;
    if (Number(payableAmount) >= 0) {
      remaining = Math.max(payableAmount - sumOtherPayments, 0);
    } else {
      remaining = Math.min(payableAmount - sumOtherPayments, 0);
    }

    const prefill =
      updatedPartialPayments[newKey] !== undefined
        ? updatedPartialPayments[newKey]
        : remaining;

    setErrormsg("");
    setOverPaid(false);
    setPaymentType(newMode);
    setAmountPaid(prefill);

    // Update partialPayments with the NEW prefilled value
    setPartialPayments({
      ...updatedPartialPayments,
      [newKey]: prefill,
    });
  };

  function handleInputChange(data, type) {
    let numValue = Number(data || 0);

    if (type === "amount") {
      // Allow optional leading minus for refunds/advance payments
      if (!/^-?\d*\.?\d*$/.test(data)) {
        return;
      }

      const updated = updatePartialPaymentsList(data);

      // Calculate total paid across all modes
      const totalPaid = Object.values(updated).reduce(
        (sum, amt) => sum + Number(amt || 0),
        0,
      );

      // Validation for Case 1 & Case 2: Must pay exact amount
      const payable = Number(payableAmount);

      if (requiresExactPayment) {
        if (totalPaid > payable) {
          setErrormsg("Total paid exceeds payable amount!");
          setOverPaid(true);
        } else if (totalPaid < payable) {
          setErrormsg(`Please pay exact amount: ₹${payable.toFixed(2)}`);
          setOverPaid(true);
        } else {
          setErrormsg("");
          setOverPaid(false);
        }
      }
    } else if (type === "bank") {
      setSelectedBank(data);
    } else if (type === "voucher") {
      setVoucherId(data);
    } else if (type === "authcode") {
      setErrormsg("");
      setAuthorizationcode(data);
    } else if (type === "description") {
      setDescription(data);
    }
  }

  const updateAdvAmt = (advAmt) => {
    setAmountPaid(advAmt);
  };

  async function savePatientPaymentDetails(invDetail) {
    // Get all payment modes that have non-zero amounts (include negative for refunds)
    const paymentModes = Object.entries(partialPayments).filter(
      ([mode, amt]) => Number(amt) !== 0,
    );

    // If no valid payments, return
    if (paymentModes.length === 0) {
      setErrormsg("Please enter payment amount");
      setOverPaid(true);
      return;
    }

    // Process each payment mode separately
    for (const [mode, amount] of paymentModes) {
      const paymentObj = { ...ERP_PATIENT_PAYMENT_OBJ };

      paymentObj.bankDepositDescription = `Patient #${patientInfo.id} ${patientInfo.fname} payment`;
      paymentObj.paymentMode = mode; // Use the specific mode from partialPayments
      paymentObj.user = loggerUserName;

      // Normalize amount and handle refund mode without double-negation
      const amtNum = Number(amount) || 0;
      if (
        paymentInitialisedMode ===
        HMS_ERPPAYMENT_PAYMENT_TYPE.REFUND_PAYMENT_ONLY
      ) {
        // Backend expects negative for refunds. If user already entered negative, keep it.
        paymentObj.paymentAmount = amtNum < 0 ? `${amtNum}` : `-${amtNum}`;
      } else {
        paymentObj.paymentAmount = `${amtNum}`; // Use the specific amount for this mode
      }

      paymentObj.customerId = patientInfo.erpCustId;
      paymentObj.customerName = patientInfo.fullName;
      paymentObj.customerInfo.customerId = patientInfo.erpCustId;
      paymentObj.customerInfo.customerName = patientInfo.fullName;
      paymentObj.paymentDate = new Date();
      paymentObj.timestamp = new Date();

      let locationId = 0;
      if (
        invDetailsPayment &&
        (invDetailsPayment.type === ERP_OUTSTANDING_BILL_LISTING ||
          invDetailsPayment.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV) &&
        paymentInitialisedMode ===
          HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES
      ) {
        locationId = invDetailsPayment?.locationId;
      } else {
        locationId = await helperServices.getLocationIdByvisitType(
          masterLocationDetails,
          patientInfo.visit.type,
        );
      }
      paymentObj.locationId = locationId;

      if (
        selectedBank &&
        (ERP_PAYMENT_MODE.Credit_Card == mode || ERP_PAYMENT_MODE.UPI == mode)
      ) {
        paymentObj.bankId = selectedBank.bankId;
        paymentObj.bankName = selectedBank.bankName;

        // For CC, use the authorization code
        if (ERP_PAYMENT_MODE.Credit_Card == mode) {
          paymentObj.checkNo = authorizationcode;
        }
      }

      if (ERP_PAYMENT_MODE.CASH != mode) {
        paymentObj.checkDate = new Date();
      }

      let customerBills = [];
      if (invDetail && invDetail.type === ERP_OUTSTANDING_BILL_LISTING) {
        customerBills.push({
          invoiceNo: invDetail.invoiceDetail.invoiceId,
          outstandingBalance: invDetail.invoiceDetail.outstandingBalance,
          paidAmount: amount, // Use specific amount for this mode
          invoiceDate: new Date(invDetail.invoiceDate),
          paymentAmount: amount, // Use specific amount for this mode
          billTotalAmount: invDetail.invoiceDetail.billTotalAmount,
          ticketId: invDetail.invoiceDetail.ticketId,
          paidBillAmount: amount, // Use specific amount for this mode
          currencyInfo: {
            currencyId: 1,
            currencyName: "INR",
            currencySymbol: "Rs",
            baseCurrency: true,
          },
        });
      } else if (
        invDetail &&
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY !=
          paymentInitialisedMode &&
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY !=
          paymentInitialisedMode
      ) {
        customerBills.push({
          invoiceNo: invDetail.invoiceId,
          outstandingBalance: invDetail.paymentAmt.replace("₹ ", ""),
          paidAmount: amount, // Use specific amount for this mode
          invoiceDate: new Date(invDetail.invoiceDate),
          previousPayment: invDetail.receivedAmt.replace("₹ ", ""),
          paymentAmount: amount, // Use specific amount for this mode
          billTotalAmount: invDetail.billAmt.replace("₹ ", ""),
          ticketId: invDetail.ticketId,
          paidBillAmount: amount, // Use specific amount for this mode
          currencyInfo: {
            currencyId: 1,
            currencyName: "INR",
            currencySymbol: "Rs",
            baseCurrency: true,
          },
          exchangerate: 1,
        });
      }

      let invPaymentDetails = [];
      if (invDetail && invDetail.type === ERP_OUTSTANDING_BILL_LISTING) {
        invPaymentDetails.push({
          ticketId: invDetail.invoiceDetail.ticketId,
          paidBillAmount: amount, // Use specific amount for this mode
          paymentAmount: invDetail.invoiceDetail.outstandingBalance,
          outstandingBalance: invDetail.invoiceDetail.outstandingBalance,
          paidAmount: amount, // Use specific amount for this mode
        });
      } else if (
        invDetail &&
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY !=
          paymentInitialisedMode &&
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY !=
          paymentInitialisedMode
      ) {
        invPaymentDetails.push({
          ticketId: invDetail.ticketId,
          paidBillAmount: amount, // Use specific amount for this mode
          paymentAmount: invDetail.paymentAmt.replace("₹ ", ""),
          outstandingBalance: invDetail.paymentAmt.replace("₹ ", ""),
          paidAmount: amount, // Use specific amount for this mode
        });
      }

      paymentObj.customerTickets = customerBills;
      paymentObj.description = paymentTowards?.description || description || "";
      paymentObj.isConsolidated = paymentTowards?.invoiceDetail?.isConsolidated;

      // Save each payment separately
      const paymentResp = await savePatientPayment(locationId, paymentObj);

      if (!paymentResp) {
        setErrormsg(`Failed to process ${mode} payment of ₹${amount}`);
        setOverPaid(true);
        return; // Stop if any payment fails
      }
    }

    // All payments successful
    if (
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY ===
        paymentInitialisedMode ||
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY ===
        paymentInitialisedMode
    ) {
      paymentTowards["status"] = HMS_PAYMENT_REUQEST_STATUS.RECEIPT_GENERATED;
      let locationId = 0;
      locationId = await helperServices.getLocationIdByvisitType(
        masterLocationDetails,
        patientInfo?.visit?.type,
      );
      paymentTowards["locationId"] = locationId;
      updatePaymentRequest(paymentTowards);
    }
    setInvDetailsPayment("");
    setPayableAmount("");
    closePaymentComponent(ERP_LABEL_PAYMENT_CLOSE_ICON);
  }

  const handleSubmit = async () => {
    // Calculate total payment across all modes
    const totalPaid = Object.values(partialPayments).reduce(
      (sum, amt) => sum + Number(amt || 0),
      0,
    );

    // Validation for Case 1 & Case 2
    if (requiresExactPayment) {
      const payableAmt = Number(payableAmount) || 0;
      if (Math.abs(totalPaid - payableAmt) > 0.01) {
        // Allow small floating point differences
        setErrormsg(
          `Please pay exact amount: ₹${payableAmt.toFixed(
            2,
          )}. Current total: ₹${totalPaid.toFixed(2)}`,
        );
        setOverPaid(true);
        return;
      }

      // Check for CC authorization code
      const ccAmount = partialPayments["CC"] || 0;
      if (
        ccAmount > 0 &&
        (!authorizationcode || authorizationcode.trim() === "")
      ) {
        setErrormsg("Please enter Authorization code for credit card payment");
        setOverPaid(true);
        return;
      }
    }

    // Clear any previous errors
    setErrormsg("");
    setOverPaid(false);

    if (
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY ===
        paymentInitialisedMode ||
      HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY ===
        paymentInitialisedMode
    ) {
      await savePatientPaymentDetails(invDetailsPayment);
    } else if (
      invDetailsPayment &&
      (invDetailsPayment.type === ERP_OUTSTANDING_BILL_LISTING ||
        invDetailsPayment.type === ERP_VISIT_FIN_SUMMARY_TYPE_INV) &&
      paymentInitialisedMode ===
        HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES
    ) {
      await savePatientPaymentDetails(invDetailsPayment);
    } else if (
      invDetailsPayment &&
      invDetailsPayment.type ===
        HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW &&
      HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR !==
        outstandingBillClearType
    ) {
      const updatedPartials = updatePartialPaymentsList(amountPaid);

      const invoicePayments = Object.entries(updatedPartials)
        .filter(([_, amt]) => Number(amt) > 0)
        .map(([label, amt]) => {
          const name = ERP_CODE_TO_INVOICE_KEY[label];
          const payment = {
            name,
            total: amt,
            chequeNo: null,
            givenAmount: amt,
          };

          if (name === "magcard" && label === "CC") {
            payment.cardPaymentAuthId = authorizationcode;
          }

          return payment;
        });
      let erpCustId = null;
      if (invDetailsPayment && ERP_BILLING_TYPE_SO === invDetailsPayment.type) {
        const currencyInfo = {
          currencyId: 1,
          baseCurrency: true,
        };
        invDetailsPayment.invoiceDetail.currencyId = 1;
        invDetailsPayment.invoiceDetail["currencyInfo"] = currencyInfo;
        invDetailsPayment.invoiceDetail.invoicePayments = invoicePayments;

        const generateInvoiceResp = await savePatientInvoice(
          invDetailsPayment.loc,
          invDetailsPayment.invoiceDetail,
          erpCustId,
        );

        if (generateInvoiceResp && generateInvoiceResp.billNumber) {
          if (invDetailsPayment?.invoiceDetail?.type === ERP_BILLING_TYPE_SO) {
            const data = {
              patientId: patientInfo.id,
              visitId: patientInfo.visit.id,
              checkType: "",
            };

            let formatted = "";
            if (patientInfo?.visit?.type === "InPatient") {
              const dischargeDateTime = patientInfo?.visit?.dischargeDate;
              const timeZone = "Asia/Kolkata";

              if (dischargeDateTime) {
                const utcDate = parseISO(dischargeDateTime);
                const localDate = utcToZonedTime(utcDate, timeZone);
                formatted = format(localDate, "yyyy-MM-dd'T'HH:mm:ss", {
                  timeZone,
                });
              }
              data.dischargeDate = formatted;
            }

            dispatch(
              patientActions.erpV2moveToBill(data, (resCb) => {
                if (resCb.successMessages) {
                  serverResposnes("Payment Successfull", MESSAGE_TYPE.SUCCESS);
                }
              }),
            );
          }
        } else {
          serverResposnes("Payment failed", MESSAGE_TYPE.ERROR);
        }
        closePaymentComponent(ERP_LABEL_PAYMENT_CLOSE_ICON);
      } else if (
        HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW ===
        paymentInitialisedMode
      ) {
        invDetailsPayment.invoiceDetail.invoicePayments = invoicePayments;
        const generateInvoiceResp = await savePatientInvoice(
          invDetailsPayment.loc,
          invDetailsPayment.invoiceDetail,
          erpCustId,
        );
        if (generateInvoiceResp && !generateInvoiceResp.respStatus) {
          serverResposnes("Payment Successfull", MESSAGE_TYPE.SUCCESS);
          closePaymentComponent(ERP_LABEL_PAYMENT_CLOSE_ICON);
        }
      }
    } else if (
      paymentInitialisedMode === HMS_ERPPAYMENT_PAYMENT_TYPE.REFUND_PAYMENT_ONLY
    ) {
      await savePatientPaymentDetails(null);
    } else {
      if (
        paymentType == ERP_PAYMENT_MODE.Credit_Card &&
        authorizationcode == null
      ) {
        setErrormsg("Please enter Authorization code for credit card payment");
        setOverPaid(true);
        return;
      }

      const updatedPartials = updatePartialPaymentsList(amountPaid);

      const totalMultiPaymentAmount = Object.values(updatedPartials).reduce(
        (sum, val) => sum + Number(val || 0),
        0,
      );

      setPartialPayments(updatedPartials);
      setAmountPaid(totalMultiPaymentAmount);

      setShowOutstandingBill(true);
    }
  };

  useEffect(() => {
    getAllBanksDetails();
  }, []);

  useEffect(() => {
    setBalanceAmount(balAmount);

    if (paymentTowards) {
      setInvDetailsPayment(paymentTowards);
      if (showOutstandingBill) {
        setPayableAmount(paymentTowards.invoiceDetail.totalInvoiceAmount);
      } else if (
        HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW ===
        paymentInitialisedMode
      ) {
        const amount = paymentTowards.invoiceDetail.totalInvoiceAmount;
        setPayableAmount(amount);
        setAmountPaid(amount);
        // Initialize partial payments with full amount in cash by default
        setPartialPayments({ [ERP_PAYMENT_MODE.CASH]: amount });
      } else if (
        HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES ===
        paymentInitialisedMode
      ) {
        setPayableAmount(billClearAmt);
        setAmountPaid(billClearAmt);
        // Initialize partial payments with full amount in cash by default
        setPartialPayments({ [ERP_PAYMENT_MODE.CASH]: billClearAmt });
      } else if (
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY ===
          paymentInitialisedMode ||
        HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY ===
          paymentInitialisedMode
      ) {
        setPayableAmount(paymentTowards.requestedAmount);
        setAmountPaid(paymentTowards.requestedAmount);
        // Ensure partialPayments contains the requested amount so validation and submit work
        setPartialPayments({
          [ERP_PAYMENT_MODE.CASH]: paymentTowards.requestedAmount,
        });
      } else {
        setPayableAmount(paymentTowards.netInvoiceClearAmt);
        setAmountPaid(paymentTowards.netInvoiceClearAmt);
      }
    }

    if (
      HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR ===
      outstandingBillClearType
    ) {
      setShowOutstandingBill(true);
      updateAdvAmt(billClearAmount);
    }
  }, [bankDetails, showOutstandingBill, balAmount, paymentTowards]);

  return (
    <>
      <div className="main-content">
        {!(
          invDetailsPayment &&
          invDetailsPayment.type === ERP_LABEL_GENERATE_INVOICE
        ) && (
          <>
            <div className="d-flex justify-content-between align-items-center p-3">
              <div className="d-flex justify-content-center">
                <ArrowBackIcon
                  onClick={(e) =>
                    closePaymentComponent(ERP_LABEL_PAYMENT_BACK_ICON)
                  }
                />
                <div className="ms-2">{ERP_LABEL_PAYMENT}</div>
              </div>
              <div>
                <CloseIcon
                  onClick={(e) =>
                    closePaymentComponent(ERP_LABEL_PAYMENT_CLOSE_ICON)
                  }
                />
              </div>
            </div>
            <div className="ms-2 px-2">
              <Breadcrumbs crumbs={breadcrumbItems} />
            </div>
            {patientInfo && patientInfo.fname && (
              <div className="w-50 header my-3 px-3">
                <span style={{ fontWeight: "bold" }}>
                  #{patientInfo.id} {patientInfo?.fname} {patientInfo?.lname}
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {patientInfo?.gender}
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {patientInfo?.age}yrs
                </span>
              </div>
            )}
          </>
        )}
        <div className="w-50 ms-2 px-2 d-flex align-items-center justify-content-between">
          {balAmount && <div className="">Balance : ₹ {balanceAmount}</div>}
          {!showOutstandingBill &&
            HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES ===
              paymentInitialisedMode && (
              <div>Bill No. : {paymentTowards.invoiceId}</div>
            )}
          {((payableAmount &&
            invDetailsPayment &&
            (invDetailsPayment.type ===
              HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW ||
              invDetailsPayment.type ===
                HMS_ERPPAYMENT_PAYMENT_TYPE.INVOICE_PAYMENT_FOR_SELECTED_INVOICES)) ||
            (payableAmount && paymentType)) && (
            <div>Payable Amount : ₹ {payableAmount}</div>
          )}
          {showOutstandingBill &&
            outstandingBillClearType ===
              HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_ADVANCE_AMOUNT_TYPE_ADVANCE_PAYMENT && (
              <div>Advance Amount : ₹ {amountPaid}</div>
            )}
          {showOutstandingBill &&
            outstandingBillClearType ===
              HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR && (
              <div>Bill Clear Amount : ₹ {amountPaid}</div>
            )}
        </div>
        {showOutstandingBill ? (
          <div className="h-100">
            <ERPOutStandingBills
              patientId={patientId}
              visitId={visitId}
              advAmt={amountPaid}
              billClearType={outstandingBillClearType}
              // updateAdvAmt={updateAdvAmt}
              updateAdvAmt={(newAmt) => {
                setAmountPaid(newAmt);
              }} // keep sync if outstanding component updates remaining
              pymtType={paymentType}
              paymentTypeWithAmount={partialPayments}
              bankDetails={selectedBank}
              Authorizationcode={authorizationcode}
              closePaymentPage={closePaymentComponent}
              description={description}
            />
          </div>
        ) : (
          <div className="d-flex align-items-center w-100 ms-2">
            <div className="w-50">
              <div className="paymentMethodsDiv">
                <div
                  className={`payment-method-box ${
                    paymentType === ERP_PAYMENT_MODE.CASH ? "active" : ""
                  }`}
                  onClick={() => updatePaymentMode(ERP_PAYMENT_MODE.CASH)}
                >
                  <img
                    className="paymentIcon"
                    src="/static/icons/rupee_cash_note-removebg-preview.png"
                    alt="CASH PAYMENT"
                  />
                </div>
                <div
                  className={`payment-method-box ${
                    paymentType === ERP_PAYMENT_MODE.Credit_Card ? "active" : ""
                  }`}
                  onClick={() =>
                    updatePaymentMode(ERP_PAYMENT_MODE.Credit_Card)
                  }
                >
                  <img
                    className="paymentIcon"
                    src="/static/icons/debit_card_icon.png"
                    alt="CARD PAYMENT"
                  />
                </div>
                <div
                  className={`payment-method-box ${
                    paymentType === ERP_PAYMENT_MODE.UPI ? "active" : ""
                  }`}
                  onClick={() => updatePaymentMode(ERP_PAYMENT_MODE.UPI)}
                >
                  <img
                    className="paymentIcon"
                    src="/static/icons/UPI_Icon.png"
                    alt="UPI PAYMENT"
                  />
                </div>
                <div
                  className={`payment-method-box ${
                    paymentType === ERP_PAYMENT_MODE.VOUCHER ? "active" : ""
                  }`}
                  onClick={() => updatePaymentMode(ERP_PAYMENT_MODE.VOUCHER)}
                >
                  <img
                    className="paymentIcon"
                    src="/static/icons/Voucher_Gift_Card.png"
                    alt="VOUCHER CARD PAYMENT"
                  />
                </div>
              </div>

              <div className="paymentInfoData">
                <div>
                  {paymentType == ERP_PAYMENT_MODE.CASH && (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Amount</div>
                        <input
                          className="ms-1"
                          type="text"
                          // readOnly={
                          //   HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_ADVANCE_PAYMENT_ONLY ===
                          //     paymentInitialisedMode ||
                          //   HMS_ERPPAYMENT_PAYMENT_TYPE.PAYMENTREQUEST_REFUND_PAYMENT_ONLY ===
                          //     paymentInitialisedMode
                          // }
                          value={amountPaid}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "amount")
                          }
                        />
                      </div>
                      {invDetailsPayment &&
                        invDetailsPayment.type ===
                          HMS_ERPPAYMENT_PAYMENT_TYPE.NEW_INVOICE_PAY_NOW &&
                        !requiresExactPayment &&
                        amountPaid > payableAmount && (
                          <div className="d-flex justify-content-between mb-2">
                            <div>Change</div>
                            <input
                              className="ms-1"
                              type="text"
                              value={(amountPaid - payableAmount).toFixed(2)}
                              //readOnly
                            />
                          </div>
                        )}
                    </>
                  )}
                  {paymentType == ERP_PAYMENT_MODE.UPI && (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Bank</div>
                        <select
                          className="ms-1"
                          value={selectedBank}
                          onChange={(event) => handleInputChange(event, "bank")}
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          {bankDetails &&
                            bankDetails.map((bank) => (
                              <option key={bank.bankId} value={bank}>
                                {bank.bankName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Paid Amount</div>
                        <input
                          className="ms-1"
                          type="text"
                          value={amountPaid}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "amount")
                          }
                        />
                      </div>
                    </>
                  )}
                  {paymentType == ERP_PAYMENT_MODE.Credit_Card && (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Bank</div>
                        <select
                          className="ms-1"
                          value={selectedBank}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "bank")
                          }
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          {bankDetails &&
                            bankDetails.map((bank) => (
                              <option key={bank.bankId} value={bank}>
                                {bank.bankName}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Authorization code</div>
                        <input
                          className="ms-1"
                          type="text"
                          value={authorizationcode || ""}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "authcode")
                          }
                        />
                      </div>

                      <div className="d-flex justify-content-between mb-2">
                        <div>Amount </div>
                        <input
                          className="ms-1"
                          type="text"
                          value={amountPaid}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "amount")
                          }
                        />
                      </div>
                    </>
                  )}
                  {paymentType == ERP_PAYMENT_MODE.VOUCHER && (
                    <>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Voucher Id</div>
                        <input
                          className="ms-1"
                          type="text"
                          value={voucherId || ""}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "voucher")
                          }
                        />
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <div>Amount</div>
                        <input
                          className="ms-1"
                          type="text"
                          value={amountPaid}
                          onChange={(event) =>
                            handleInputChange(event.target.value, "amount")
                          }
                        />
                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-between mb-2">
                    <div>Description</div>
                    <input
                      className="ms-1"
                      type="text"
                      value={description || ""}
                      onChange={(event) =>
                        handleInputChange(event.target.value, "description")
                      }
                    />
                  </div>
                  {overPaid && <div style={{ color: "red" }}>{errormsg}</div>}
                </div>

                <div className="paymentButtonMainDiv">
                  <div className="justify-content-around">
                    <button
                      className="bg-primary text-white rounded p-2 me-3"
                      onClick={() => handleSubmit()}
                      disabled={overPaid}
                    >
                      {ERP_LABEL_SUBMIT}
                    </button>
                    <button
                      className="bg-white rounded p-2"
                      onClick={() =>
                        closePaymentComponent(ERP_LABEL_PAYMENT_CLOSE_ICON)
                      }
                    >
                      {ERP_LABEL_CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-50 d-flex justify-content-center">
              {paymentType == ERP_PAYMENT_MODE.VOUCHER && <></>}
              {paymentType == ERP_PAYMENT_MODE.UPI && <></>}
              {paymentType == ERP_PAYMENT_MODE.Credit_Card && (
                <>
                  <img
                    className="justify-content-center"
                    style={{ height: "7rem" }}
                    src="/static/icons/Credit_Card_Payment_Image.png"
                    alt="CASH PAYMENT Image"
                  />
                </>
              )}
              {paymentType == ERP_PAYMENT_MODE.CASH && (
                <>
                  <img
                    style={{ height: "7rem" }}
                    src="/static/icons/Hand_Cash_Payment_Image.png"
                    alt="CASH PAYMENT Image"
                  />
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
